import React from 'react';
import HeaderOneLine from 'common/components/HeaderOneLine/HeaderOneLine';
import Loadable from 'common/libs/Loadable/Loadable';
import DefaultLoadingScreen from 'common/components/DefaultLoadingScreen/DefaultLoadingScreen';

const HelpCenterSearch = Loadable({
  loader: () =>
    import(/* webpackChunkName: "HelpCenterSearch" */ '../containers/HelpCenterSearchContainer.js'),
  loading: DefaultLoadingScreen,
});

const HelpCenterSearchScreen = props => <HelpCenterSearch {...props} />;
HelpCenterSearchScreen.navigationOptions = ({ navigation }) => {
  const headerTitle = navigation.getParam('title', 'Hasil Pencarian');
  return {
    headerTitle: <HeaderOneLine title={headerTitle} />,
  };
};
export default HelpCenterSearchScreen;
